<div style="max-width: 900px; margin: 0 auto; padding-top: 2em; margin-bottom: 20px;">
  @if (settings) {
    <h1>{{settings.practiceName}}</h1>
  }
  @if (settings) {
    <h5>{{settings.locationName}}</h5>
  }
  @if (settings && settings.logoUrl) {
    <div>
      <img [src]="settings.logoUrl" style="max-width: 200px" />
    </div>
  }
  <mat-vertical-stepper linear="true" appMatVerticalStepperScroller class="mat-elevation-z4" style="border-radius: 5px;">
    <mat-step [stepControl]="form.get('pin')" editable="false">
      <ng-template matStepLabel>Welcome!</ng-template>
      <p>Please enter a minimum 4 digit pin number to secure your patient forms or continue from where you left off.</p>
      <mat-form-field>
        <mat-label>Pin</mat-label>
        <input type="number" matInput [formControl]="form.get('pin')" (keyup.enter)="nextBtn._elementRef.nativeElement.click()" placeholder="Security Pin" />
      </mat-form-field>
      <div class="step-btn-box">
        <button type="button" color="primary" mat-raised-button #nextBtn (click)="verifyPin()">Next</button>
        @if (startOverEnabled) {
          <button type="button" mat-flat-button color="accent" matStepperNext>Start Over</button>
        }
      </div>
    </mat-step>

    <mat-step [stepControl]="form.get('basicInfo')">
      <form [formGroup]="form.get('basicInfo')">
        <ng-template matStepLabel>Basic Information</ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Patient First Name</mat-label>
                <input type="text" matInput formControlName="patientFirstName" placeholder="Patient First Name" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Patient Last Name</mat-label>
                <input type="text" matInput formControlName="patientLastName" placeholder="Patient Last Name" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Patient Birthdate</mat-label>
                <input matInput formControlName="patientBirthdate" [matDatepicker]="patientBirthdatePicker" placeholder="Patient's Birthdate" [matDatepickerFilter]="datePickerFilter" />
                <mat-datepicker-toggle matSuffix [for]="patientBirthdatePicker"></mat-datepicker-toggle>
                <mat-datepicker #patientBirthdatePicker startView="multi-year" [startAt]="birthdateStartAt" [touchUi]="touchUI"></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-radio-group formControlName="gender">
                <mat-radio-button value="M">Male</mat-radio-button>
                <mat-radio-button value="F">Female</mat-radio-button>
                <mat-radio-button value="U">Undisclosed</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div class="step-btn-box">
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('patientDetails')">
      <form [formGroup]="form.get('patientDetails')">
        <ng-template matStepLabel>Patient Details</ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Street Address</mat-label>
                <input type="text" formControlName="street" matInput placeholder="Street Address" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Cell Phone</mat-label>
                <input type="text" formControlName="cellPhone" matInput placeholder="Cell Phone" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>City</mat-label>
                <input type="text" formControlName="city" matInput placeholder="City" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Work Phone</mat-label>
                <input type="tel" formControlName="workPhone" matInput placeholder="Work Phone" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="state">
                  @for (st of stateOptions; track st) {
                    <mat-option [value]="st.abbreviation">{{st.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input type="email" formControlName="email" matInput placeholder="Email" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Zipcode</mat-label>
                <input type="text" formControlName="zipcode" matInput placeholder="Zipcode" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Employer</mat-label>
                <input type="text" formControlName="employer" matInput placeholder="Employer Name" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Social Security Number</mat-label>
                <input type="text" formControlName="ssn" matInput placeholder="000-00-0000" />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('currentDentist')">
      <form [formGroup]="form.get('currentDentist')">
        <ng-template matStepLabel>Current Dentist</ng-template>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Current Dentist's Name</mat-label>
                <input type="text" formControlName="dentistName" matInput placeholder="Current Dentist's Name" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Last Cleaning</mat-label>
                <input formControlName="lastCleaning" [matDatepicker]="lastCleaningDatepicker" matInput placeholder="Date of Last Cleaning" />
                <mat-datepicker-toggle matSuffix [for]="lastCleaningDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #lastCleaningDatepicker startView="year" [touchUi]="touchUI"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-8">
              <mat-form-field>
                <mat-label>Current Dental Office</mat-label>
                <input type="text" formControlName="officeName" matInput placeholder="Current Dental Office" />
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>Referral Name</mat-label>
                <input type="text" formControlName="referralName" matInput placeholder="Whom may we thank for referring you to our office?" />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('responsibleParty')">
      <form [formGroup]="form.get('responsibleParty')">
        <ng-template matStepLabel>Responsible Party Information</ng-template>
        <div>
          <p>Are you making this appointment for yourself?</p>
          <mat-radio-group formControlName="hasResponsible" #primaryResponsibleParty="matRadioGroup">
            <mat-radio-button [value]="false">Yes</mat-radio-button>
            <mat-radio-button [value]="true">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="container-fluid">
          <div class="row" [style.display]="primaryResponsibleParty.value ? '' : 'none'">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>First Name</mat-label>
                <input type="text" formControlName="firstName" matInput placeholder="First Name" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input type="text" formControlName="lastName" matInput placeholder="Last Name" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Birthdate</mat-label>
                <input formControlName="birthdate" matInput [matDatepicker]="responsibleDatePicker" placeholder="Birthdate" [required]="primaryResponsibleParty.value" />
                <mat-datepicker-toggle matSuffix [for]="responsibleDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #responsibleDatePicker startView="multi-year" [touchUi]="touchUI"></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Social Security Number</mat-label>
                <input type="text" formControlName="ssn" matInput placeholder="Social Security Number" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Relationship to Patient</mat-label>
                <input type="text" formControlName="relationship" matInput placeholder="Relationship To Patient" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Maritial Status</mat-label>
                <input type="text" formControlName="maritalStatus" matInput placeholder="Marital Status" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Street Address</mat-label>
                <input type="text" formControlName="street" matInput placeholder="Street Address" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Cell Phone</mat-label>
                <input type="tel" formControlName="cellPhone" matInput placeholder="Cell Phone" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>City</mat-label>
                <input type="text" formControlName="city" matInput placeholder="City" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Work Phone</mat-label>
                <input type="tel" formControlName="workPhone" matInput placeholder="Work Phone" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>State</mat-label>
                <mat-select formControlName="state" [required]="primaryResponsibleParty.value">
                  @for (st of stateOptions; track st) {
                    <mat-option [value]="st.abbreviation">{{st.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input type="email" formControlName="email" matInput placeholder="Email" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Zipcode</mat-label>
                <input type="text" formControlName="zipcode" matInput placeholder="Zipcode" [required]="primaryResponsibleParty.value" />
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Employer Name</mat-label>
                <input type="text" formControlName="employer" matInput placeholder="Employer Name" />
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <mat-checkbox formControlName="emergencyContact">Check if this individual is an emergency contact for the patient</mat-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-divider style="margin: 1.5em"></mat-divider>
              Are we currently treating any other family members?
            </div>
            <div class="col-12">
              <mat-radio-group formControlName="hasOtherFamily" #otherFamilySeen="matRadioGroup">
                <mat-radio-button [value]="true">Yes</mat-radio-button>
                <mat-radio-button [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-12">
              <mat-form-field [style.display]="otherFamilySeen.value ? '' : 'none'">
                <mat-label>Names of other family members</mat-label>
                <input type="text" formControlName="otherFamily" matInput placeholder="Names of other family members" />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('responsiblePartyAlt')">
      <form [formGroup]="form.get('responsiblePartyAlt')">
        <ng-template matStepLabel>Secondary Responsible Party</ng-template>

        Is there a secondary responsible party you would like to add?
        <div>
          <mat-radio-group formControlName="hasResponsibleAlt" #secondaryResponsibleParty="matRadioGroup">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>

        <div [style.display]="secondaryResponsibleParty.value ? '' : 'none'">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>First Name</mat-label>
                  <input type="text" formControlName="firstName" matInput placeholder="First Name" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Last Name</mat-label>
                  <input type="text" formControlName="lastName" matInput placeholder="Last Name" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Birthdate</mat-label>
                  <input formControlName="birthdate" matInput [matDatepicker]="responsibleAltDatePicker" placeholder="Birthdate" [required]="secondaryResponsibleParty.value" />
                  <mat-datepicker-toggle matSuffix [for]="responsibleAltDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #responsibleAltDatePicker startView="multi-year" [touchUi]="touchUI"></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Social Security Number</mat-label>
                  <input type="text" formControlName="ssn" matInput placeholder="Social Security Number" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Relationship to Patient</mat-label>
                  <input type="text" formControlName="relationship" matInput placeholder="Relationship To Patient" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Marital Status</mat-label>
                  <input type="text" formControlName="maritalStatus" matInput placeholder="Marital Status" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Street Address</mat-label>
                  <input type="text" formControlName="street" matInput placeholder="Street Address" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Cell Phone</mat-label>
                  <input type="tel" formControlName="cellPhone" matInput placeholder="Cell Phone" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>City</mat-label>
                  <input type="text" formControlName="city" matInput placeholder="City" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Work Phone</mat-label>
                  <input type="tel" formControlName="workPhone" matInput placeholder="Work Phone" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>State</mat-label>
                  <mat-select formControlName="state" [required]="secondaryResponsibleParty.value">
                    @for (st of stateOptions; track st) {
                      <mat-option [value]="st.abbreviation">{{st.name}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Email</mat-label>
                  <input type="email" formControlName="email" matInput placeholder="Email" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Zipcode</mat-label>
                  <input type="text" formControlName="zipcode" matInput placeholder="Zipcode" [required]="secondaryResponsibleParty.value" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field>
                  <mat-label>Employer Name</mat-label>
                  <input type="text" formControlName="employer" matInput placeholder="Employer Name" />
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-checkbox formControlName="emergencyContact">Check if this individual is an emergency contact for the patient</mat-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('insurance')">
      <form [formGroup]="form.get('insurance')">
        <ng-template matStepLabel>Insurance</ng-template>
        <p>Do you have Dental Insurance?</p>
        <mat-radio-group formControlName="hasInsurance" #primaryInsurance="matRadioGroup">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>

        <div [style.display]="primaryInsurance.value ? '' : 'none'">
          <mat-form-field>
            <mat-label>Name of Policy Holder</mat-label>
            <input type="text" formControlName="policyHolder" matInput placeholder="Name of Policy Holder" [required]="primaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Insurance Company Name</mat-label>
            <input type="text" formControlName="insuranceCompanyName" matInput placeholder="Insurance Company Name" [required]="primaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Policy ID</mat-label>
            <input type="text" formControlName="policyId" matInput placeholder="Policy ID" [required]="primaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Policy Group ID</mat-label>
            <input type="text" formControlName="policyGroupId" matInput placeholder="Policy Group ID" [required]="primaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Insurance Company's Phone</mat-label>
            <input type="text" formControlName="insuranceCompanyPhone" matInput placeholder="Insurance Company's Phone" [required]="primaryInsurance.value" />
          </mat-form-field>

          <div class="upload-box">
            <p>Upload photo of the <strong>front</strong> of insurance card</p>
            <image-uploader [maxSize]="1000" formControlName="cardFront"></image-uploader>
          </div>
          <div class="upload-box">
            <p>Upload photo of the <strong>back</strong> of insurance card</p>
            <image-uploader [maxSize]="1000" formControlName="cardBack"></image-uploader>
          </div>
        </div>

        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('insuranceAlt')">
      <form [formGroup]="form.get('insuranceAlt')">
        <ng-template matStepLabel>Secondary Insurance</ng-template>
        <p>Do you have Secondary Dental Insurance?</p>
        <mat-radio-group formControlName="hasInsuranceAlt" #secondaryInsurance="matRadioGroup">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>

        <div [style.display]="secondaryInsurance.value ? '' : 'none'">
          <mat-form-field>
            <mat-label>Name of Policy Holder</mat-label>
            <input type="text" formControlName="policyHolder" matInput placeholder="Name of Policy Holder" [required]="secondaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Insurance Company Name</mat-label>
            <input type="text" formControlName="insuranceCompanyName" matInput placeholder="Insurance Company Name" [required]="secondaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Policy ID</mat-label>
            <input type="text" formControlName="policyId" matInput placeholder="Policy ID" [required]="secondaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Policy Group ID</mat-label>
            <input type="text" formControlName="policyGroupId" matInput placeholder="Policy Group ID" [required]="secondaryInsurance.value" />
          </mat-form-field>
          <mat-form-field>
            <mat-label>Insurance Company's Phone</mat-label>
            <input type="text" formControlName="insuranceCompanyPhone" matInput placeholder="Insurance Company's Phone" [required]="secondaryInsurance.value" />
          </mat-form-field>

          <div class="upload-box">
            <p>Upload photo of the <strong>front</strong> of insurance card</p>
            <image-uploader [maxSize]="1000" formControlName="cardFront"></image-uploader>
          </div>
          <div class="upload-box">
            <p>Upload photo of the <strong>back</strong> of insurance card</p>
            <image-uploader [maxSize]="1000" formControlName="cardBack"></image-uploader>
          </div>
        </div>

        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('medical')">
      <form [formGroup]="form.get('medical')">
        <ng-template matStepLabel>Medical History</ng-template>
        <h4>Please select any medical condtions which are applicable for the patient</h4>
        <mat-selection-list role="listbox" formControlName="conditions">
          @for (condition of medicalConditions; track condition) {
            <mat-list-option [value]="condition">{{condition}}</mat-list-option>
          }
        </mat-selection-list>

        <h4>Please select any statuses applicable to the patient</h4>
        <mat-selection-list role="listbox" formControlName="statuses">
          @for (status of medicalStatuses; track status) {
            <mat-list-option [value]="status.value">{{status.name}}</mat-list-option>
          }
        </mat-selection-list>

        <mat-form-field>
          <mat-label>Medications</mat-label>
          <input type="text" formControlName="medications" matInput placeholder="Currently taking any medications?" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Other Medical Conditions</mat-label>
          <input type="text" formControlName="otherConditions" matInput placeholder="Are there any other medical conditions we should know about?" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>Drug Allergies</mat-label>
          <input type="text" formControlName="drugAllergies" matInput placeholder="Are there any allergies to certain medications?" />
        </mat-form-field>

        <mat-checkbox formControlName="osteoporosisMedication">Currently taking osteoporosis Medication?</mat-checkbox>
        <div>
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('outsideConsult')">
      <form [formGroup]="form.get('outsideConsult')">
        <ng-template matStepLabel>Outside Consultation</ng-template>
        Are you currently receiving any other orthodontic consultations?
        <mat-radio-group formControlName="receivingConsult">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>

        <mat-form-field>
          <mat-label>What are you currently seeking orthodontic services for?</mat-label>
          <input type="text" formControlName="treatmentPurpose" matInput placeholder="Seeking Orthodontic Services For..." />
        </mat-form-field>
        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('agreement1')">
      <ng-template matStepLabel>Appointment Policy</ng-template>
      <div class="agreement-scroller" [innerHtml]="settings != null ? domSanitizer.bypassSecurityTrustHtml(settings.appointmentPolicy) : 'There was a problem loading the agrement.'">
      </div>
      <p>I have read and agree to the scheduling information above:</p>
      <mat-checkbox #iAgree [formControl]="form.get('agreement1')">I Agree</mat-checkbox>
      <div class="step-btn-box">
        <button mat-button color="accent" mat-stroked-button matStepperPrevious>Back</button>
        <button mat-button color="primary" mat-raised-button matStepperNext (click)="alertCheckboxNotChecked(iAgree)">Next</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="form.get('agreement2')">
      <ng-template matStepLabel>Informed Consent</ng-template>
      <div class="agreement-scroller" [innerHtml]="settings != null ? domSanitizer.bypassSecurityTrustHtml(settings.informedConsent) : 'There was a problem loading the agrement.'">
      </div>
      <p>
        I have read, understood and have had all my questions answered regarding the risks and limitations of orthodontic treatment. I also consent to the use of all orthodontic records by the doctor in scientific meetings and demonstrations:
      </p>
      <mat-checkbox #iUnderstand [formControl]="form.get('agreement2')">I Understand</mat-checkbox>
      <div class="step-btn-box">
        <button mat-button color="accent" mat-stroked-button matStepperPrevious>Back</button>
        <button mat-button color="primary" mat-raised-button matStepperNext (click)="alertCheckboxNotChecked(iUnderstand)">Next</button>
      </div>
    </mat-step>
    <mat-step [stepControl]="form.get('agreement3')">
      <ng-template matStepLabel>Orthodontic Insurance</ng-template>
      <div class="agreement-scroller" [innerHtml]="settings != null ? domSanitizer.bypassSecurityTrustHtml(settings.orthodonticInsurance) : 'There was a problem loading the agrement.'">
      </div>
      <p>To the extent permitted by law, I consent to your use and disclosure of my protected health information to carry out payment activities in connection with my claim:</p>
      <mat-checkbox #iConsent [formControl]="form.get('agreement3')">I Consent</mat-checkbox>
      <div class="step-btn-box">
        <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
        <button type="button" color="primary" mat-raised-button matStepperNext (click)="alertCheckboxNotChecked(iConsent)">Next</button>
      </div>
    </mat-step>

    <mat-step [stepControl]="form.get('protectedRelease')">
      <form [formGroup]="form.get('protectedRelease')">
        <ng-template matStepLabel>Protected Release</ng-template>
        <mat-form-field>
          <mat-label>Additional Emergency Contact</mat-label>
          <input type="text" formControlName="additionalContact" matInput placeholder="Additional Emergency Contact Name" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Relationship to Patient</mat-label>
          <input type="text" formControlName="additionalContactRelationship" matInput placeholder="Relationship to Patient" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Emergency Contact Phone</mat-label>
          <input type="text" formControlName="additionalContactPhone" matInput placeholder="Emergency Contact Phone" />
        </mat-form-field>

        <p>Periodically our office posts photos of our patients on our website, Facebook page, and other marketing material. This is a consent authorizing us to use those pictures for these purposes.</p>
        <mat-radio-group formControlName="photoConsent">
          <mat-radio-button [value]="true"><strong>I authorize</strong></mat-radio-button>
          <mat-radio-button [value]="false"><strong>I do not authorize</strong></mat-radio-button>
        </mat-radio-group>
        <p>
          ...the use and disclosure of my name, photo/video images, and/or testimonial for marketing purposes. I understand that information disclosed pursuant to this authorization may be subject to re-disclosure and may no longer be protected by HIPAA privacy regulations.
        </p>

        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('selfie')">
      <form [formGroup]="form.get('selfie')">
        <ng-template matStepLabel>Selfie</ng-template>
        <p>We love getting to know our patients and to help us get to know you better we would like to capture a picture of your best smile (or the patient's smile in case you are filling this out for a child). If you are on mobile then snap your best selfie and upload it here. <em>If you are on a computer or otherwise cannot upload a picture right now this step is optional.</em></p>

        <mat-tab-group animationDuration="0ms">
          <mat-tab label="Live Snapshot">
            <button mat-button (click)="startSnapshotCamera()">Open Camera</button> <br />
            <div [style.visibility]="(snapshotStream && snapshotStream.active) ? 'visible': 'hidden'" style="position: relative; display: inline-block">
              <video autoplay="autoplay" #snapshotVideo style="display: block; max-width: 100%"></video>
              <button mat-fab [color]="form.get('selfie.image').value ? 'primary' : 'accent'" (click)="takePicture()" style="position: absolute; bottom: 1em; z-index: 10; left: 44%">
                <mat-icon [style.visibility]="form.get('selfie.image').value ? 'visible' : 'hidden'">check</mat-icon>
              </button>
            </div>
          </mat-tab>
          <mat-tab label="Upload Image">
            <div style="padding: 1em;">
              <image-uploader [thumbnail]="false" [maxSize]="300" (image)="form.get('selfie').patchValue({image : $event})"></image-uploader>
            </div>
          </mat-tab>
        </mat-tab-group>

        @if (form.get('selfie.image').value) {
          <img [src]="form.get('selfie.image').value" style="max-width: 100px" />
        }

        <div>
          <button type="button" color="accent" mat-stroked-button matStepperPrevious (click)="stopSnapshotCamera();">Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext (click)="stopSnapshotCamera();">Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="form.get('consent')">
      <form [formGroup]="form.get('consent')">
        <ng-template matStepLabel>Sign</ng-template>
        <p><strong>By checking this box and typing your name below, you verify that all information you have entered is accurate and current.</strong></p>
        <mat-checkbox formControlName="agreement" #iVerify><strong>I verify all entered information</strong></mat-checkbox> <br /><br />
        <p><em>CONSENT: The undersigned hereby authorizes the doctor to take x-rays, study models, photographs to make a thorough diagnosis of the patient’s orthodontic needs and send dentist information regarding diagnostic findings. I understand that where appropriate, credit bureau reports may be obtained.</em></p>
        @if (hasAddendum()) {
          <p>{{settings.agreementAddendum}}</p>
        }
        <div>
          <mat-form-field>
            <mat-label>Full Name</mat-label>
            <input type="text" formControlName="signature" matInput placeholder="Please type your Full Name" />
          </mat-form-field>
          <digital-signature #signature formControlName="signatureImage" [trigger]="requestSignature" [required]="true"></digital-signature>
        </div>

        <div class="step-btn-box">
          <button type="button" color="accent" mat-stroked-button matStepperPrevious>Back</button>
          <button type="button" color="primary" mat-raised-button matStepperNext (click)="alertCheckboxNotChecked(iVerify);alertSignatureNotSigned(signature)">Save &amp; Finish</button>
        </div>
      </form>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Complete</ng-template>
      <p>
        Thank you for taking the time to submit your digital forms! We are looking forward to seeing you at your appointment.
      </p>
    </mat-step>
  </mat-vertical-stepper>
</div>
